<template>
  <b-row >
    <b-col style="height: 80px;">
      <div class="white-box">
        <div v-if="showDiff" class="card-period-diff">
          <slot name="diff"></slot>
          <slot name="arrow"></slot>
        </div>
        <div class="card-align-text">
          <b-col cols="auto" class="px-0">
            <slot name="image"></slot>
          </b-col>
          <b-col col class="line-height-1 text-base pl-2 pl-lg-2">
            <div class="text-20 text-left" name="info">{{ info }}</div>
            <div class="text-14 text-left" name="title">{{ title }}</div>
            <slot name="extra_info"></slot>
          </b-col>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: [
    'info',
    'title',
    'showDiff'
  ]
}
</script>

<style>
  .img-box {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70px;
    width: 70px;
  }

  .card-period-diff {
    position: absolute;
    top: 5px;
    right: 25px;
    float: right;
    display: flex;
    align-items: center;
    height: fit-content;
  }

  .card-align-text {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .card-align-text > .col-auto {
    flex: 0 0 auto;
  }

  .card-align-text > .col {
    flex: 1 1 auto;
    min-width: 0;
  }

  div[name="title"] {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .extra-info-card {
    font-size: 9px;
    float: left;
  }
</style>
